// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"SearchBox_searchBox__3RFc_","searchTextField":"SearchBox_searchTextField__3oaI3","MuiInputBase-root":"SearchBox_MuiInputBase-root__1BeHR"};